<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="ch00_fm03_title"></a><a id="page_5"></a><strong>STICK-TO-IT-IVENESS</strong></h1>
<p class="bsubtitlecenter"><strong>Inspirations to Get You Where You Want to Go</strong></p>
<p class="authorcenter">Addie Johnson</p>
<p class="publisher"><img alt="images" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_title.vue?9efd0268